<template>
  <div class="product-list">
    <ProductSearch />
    <hr>
    <div style="text-align: right;">
      <b-button variant="primary" to="new">新規登録</b-button>
    </div>
    <ProductPager />
    <ProductTable />
    <ProductPager />
  </div>
</template>

<script>
import ProductSearch from './ProductSearch';
import ProductTable from './ProductTable';
import ProductPager from './ProductPager';

export default {
  name: 'ProductList',
  components: { ProductSearch, ProductTable, ProductPager },
};
</script>

<style scoped>
</style>
